import * as React from 'react';
import PricingCard from '../components/PricingCard';
import './PricingPage.css';
import { apiRequest } from '../api/client';
import config from '../config';
interface Plan {
  title: string;
  price: string;
  features: string[];
  highlight?: boolean;
}

const PricingPage: React.FC = () => {
  const [plans, setPlans] = React.useState<Plan[]>([]);
  const [selectedPlan, setSelectedPlan] = React.useState<string | null>(null);

  React.useEffect(() => {
    apiRequest<Plan[]>('/plans')
      .then(setPlans)
      .catch(console.error);
  }, []);
  return (
    <div className="pricing-page">
      <div id="pricing-header" className="fade-in">
        <h1>Simple, Transparent Pricing</h1>
        <p>Choose a plan that fits your needs</p>
      </div>
      <div className="pricing-grid">
        {plans.map((plan, i) => (
        <div className="fade-in" style={{ animationDelay: `${0.2 + i * 0.2}s`}} key={plan.title}>

        <PricingCard
            title={plan.title}
            price={plan.price}
            features={plan.features}
            highlight={plan.highlight}
          />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPage;
